import { jsx as t, jsxs as k, Fragment as J } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Ne, AlertActionCloseButton as nn, Page as rn, Modal as vt, ModalVariant as an, TextContent as ln, Text as ke, Button as q, Spinner as bt, FormHelperText as ze, HelperText as Je, HelperTextItem as Ye, Popover as sn, Icon as qe, FormGroup as Ct, NumberInput as on, ValidatedOptions as W, InputGroup as Te, InputGroupItem as Ue, TextInput as xe, Select as Ae, SelectList as Ee, SelectOption as Qe, MenuToggle as pe, MenuToggleStatus as Xe, TextInputGroup as kt, TextInputGroupMain as wt, ChipGroup as Ze, Chip as et, TextInputGroupUtilities as It, Switch as cn, TextArea as St, FileUpload as dn, Title as un, Card as hn, CardHeader as fn, CardTitle as pn, CardBody as mn, Grid as gn, GridItem as st, PageSection as yn, JumpLinks as vn, JumpLinksItem as bn, ButtonVariant as Ie, Checkbox as Cn, Radio as kn, MenuFooter as wn, Dropdown as In, DropdownList as Sn, DropdownItem as ot, Masthead as Tn, MastheadToggle as xn, PageToggleButton as An, MastheadBrand as En, MastheadContent as Rn, Toolbar as we, ToolbarContent as $e, ToolbarItem as z, Avatar as Dn, Bullseye as Fn, EmptyState as On, EmptyStateIcon as ct, EmptyStateHeader as Pn, EmptyStateBody as Ln, EmptyStateFooter as Vn, EmptyStateActions as Mn, SearchInput as Bn, Divider as _n, Pagination as Nn, Badge as qn } from "@patternfly/react-core";
import { createContext as Tt, useContext as xt, useRef as ne, useEffect as ae, useCallback as he, useState as E, useMemo as $, isValidElement as At, forwardRef as Un, useId as Et, Fragment as Rt, Children as Dt, Component as $n } from "react";
import { useTranslation as U } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, ExclamationTriangleIcon as jn, HelpIcon as Gn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Ot, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as ir, GithubIcon as sr, MinusCircleIcon as or, PlusCircleIcon as Pt, EllipsisVIcon as cr, BarsIcon as dr, SearchIcon as ur, SyncAltIcon as hr } from "@patternfly/react-icons";
import { useFormContext as Re, Controller as oe, useController as De, FormProvider as fr, useWatch as pr } from "react-hook-form";
import { get as N, intersectionBy as mr, cloneDeep as gr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as yr } from "@patternfly/react-styles";
import { Table as vr, TableVariant as br, Thead as Cr, Tr as Ce, Th as Me, Tbody as dt, Td as le, ExpandableRowContent as kr, ActionsColumn as wr, cellWidth as Ir, TableText as Sr } from "@patternfly/react-table";
import './main.css';function tt(e, n) {
  const r = Tt(n);
  return r.displayName = e, r;
}
const Tr = ["error", "errorMessage"], Be = "error_description";
function xr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Lt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Ar(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Er(n);
}
function Er(e) {
  if (typeof e == "object" && e !== null && Be in e && typeof e[Be] == "string")
    return e[Be];
}
function Lt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Tr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Rr = () => Math.floor(Math.random() * 1e3);
function Dr(e) {
  return e != null;
}
function nt(e) {
  const n = xt(e);
  if (Dr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Fr() {
  const e = ne(!1), n = ne(/* @__PURE__ */ new Set());
  ae(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Or({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Ne[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Pr = 8e3, Vt = tt(
  "AlertContext",
  void 0
), Ka = () => nt(Vt), Lr = ({ children: e }) => {
  const { t: n } = U(), r = Fr(), [a, l] = E([]), i = (c) => l((h) => h.filter((u) => u.id !== c)), s = he(
    (c, h = Ne.success, u) => {
      const p = {
        id: Rr(),
        message: c,
        variant: h,
        description: u
      };
      l((m) => [p, ...m]), r(() => i(p.id), Pr);
    },
    [r]
  ), o = he(
    (c, h) => {
      const u = n(c, { error: xr(h) }), p = Ar(h);
      s(u, Ne.danger, p);
    },
    [s, n]
  ), d = $(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ k(Vt.Provider, { value: d, children: [
    /* @__PURE__ */ t(Or, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Vr = (e) => {
  const { t: n, i18n: r } = U(), a = e.error, l = Mr(a), i = Lt(a);
  console.error(a);
  function s() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: an.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(q, { variant: "primary", onClick: s, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: l ? /* @__PURE__ */ t(ke, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(ke, { children: n(i) }) : /* @__PURE__ */ t(ke, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Mr(e) {
  return e instanceof Error ? e.message : null;
}
function Br(e, n, r) {
  const [a, l] = E(
    () => e.getItem(n) ?? r
  ), i = he((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return ae(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Mt(e, n, r) {
  const a = $(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Br(
    e,
    n,
    a
  ), s = $(() => JSON.parse(l), [l]), o = he(
    (d) => i(JSON.stringify(d)),
    []
  );
  return [s, o];
}
const Bt = tt(
  "HelpContext",
  void 0
), _r = () => nt(Bt), Nr = ({ children: e }) => {
  const [n, r] = Mt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Bt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, qr = [
  "code",
  "state",
  "session_state",
  "iss",
  "error",
  "error_description",
  "error_uri",
  "kc_action",
  "kc_action_status"
];
function Ur(e) {
  const n = new URL(e), r = n.searchParams;
  if (!(!r.has("code") && !r.has("error")) && !r.has("state")) {
    for (const a of qr)
      r.delete(a);
    return n.toString();
  }
}
const $r = () => Tt(void 0);
let Ke;
const Ha = () => {
  const e = xt(
    Ke
  );
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, ja = ({
  environment: e,
  keycloak: n,
  children: r
}) => {
  Ke = $r();
  const a = ne(!1), [l, i] = E(!!n), [s, o] = E(), d = $(() => {
    if (n)
      return n;
    const c = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e, n]);
  return ae(() => {
    if (n || a.current)
      return;
    const c = Ur(window.location.href);
    c && window.history.replaceState(window.history.state, "", c), d.init({
      onLoad: "login-required",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => i(!0)).catch((u) => o(u)), a.current = !0;
  }, [d, n]), s ? /* @__PURE__ */ t(Vr, { error: s }) : l ? /* @__PURE__ */ t(Ke.Provider, { value: { environment: e, keycloak: d }, children: /* @__PURE__ */ t(Lr, { children: /* @__PURE__ */ t(Nr, { children: r }) }) }) : /* @__PURE__ */ t(bt, {});
};
function Ga() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Wa = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: d = q,
  children: c,
  ...h
}) => {
  const [u, p] = E(!1);
  return /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t(
      d,
      {
        variant: i,
        onClick: () => p(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: u,
        onClose: () => p(!1),
        actions: [
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                p(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => p(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, _t = ({ message: e, ...n }) => /* @__PURE__ */ t(ze, { ...n, children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), Nt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: i } = _r(), s = l ? jn : Gn;
  return i ? /* @__PURE__ */ t(sn, { bodyContent: e, children: /* @__PURE__ */ k(J, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          qe,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(s, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      qe,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(s, {})
      }
    )
  ] }) }) : null;
};
function ce(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Y = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...s
}) => /* @__PURE__ */ k(
  Ct,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: At(a) ? a : a ? /* @__PURE__ */ t(Nt, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...s,
    children: [
      i,
      l && /* @__PURE__ */ t(_t, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), za = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Re();
  return /* @__PURE__ */ t(
    Y,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const d = !!r.rules?.required, c = ce(r.rules?.min), h = o.value ?? r.defaultValue, u = (p) => o.onChange(
              c !== void 0 ? Math.max(p, Number(c)) : p
            );
            return /* @__PURE__ */ t(
              on,
              {
                ...l,
                id: e,
                value: h,
                validated: s[e] ? W.error : W.default,
                required: d,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => u(h + 1),
                onMinus: () => u(h - 1),
                onChange: (p) => {
                  const m = Number(p.currentTarget.value);
                  u(isNaN(m) ? r.defaultValue : m);
                }
              }
            );
          }
        }
      )
    }
  );
}, Kr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = U(), [l, i] = E(!0);
  return /* @__PURE__ */ k(Te, { children: [
    /* @__PURE__ */ t(Ue, { isFill: !0, children: /* @__PURE__ */ t(
      xe,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      q,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, qt = Un(
  (e, n) => /* @__PURE__ */ t(Kr, { ...e, innerRef: n })
);
qt.displayName = "PasswordInput";
const Ja = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ k(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          qt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? W.error : W.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { children: e.helperText }) }) })
      ]
    }
  );
}, Hr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  isDisabled: o,
  isFullWidth: d = !0,
  onSelect: c,
  ...h
}) => {
  const {
    control: u,
    formState: { errors: p }
  } = Re(), [m, y] = E(!1), R = ce(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: R,
      error: N(p, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: u,
          render: ({ field: { onChange: g, value: f } }) => /* @__PURE__ */ t(
            Ae,
            {
              ...h,
              variant: "default",
              onClick: () => y(!m),
              onOpenChange: () => y(!1),
              selected: te(a) ? a.filter(
                (b) => Array.isArray(f) ? f.includes(b.key) : f === b.key
              ).map((b) => b.value) : f,
              toggle: (b) => /* @__PURE__ */ t(
                pe,
                {
                  id: e || n,
                  ref: b,
                  onClick: () => y(!m),
                  isExpanded: m,
                  isFullWidth: d,
                  status: N(p, n) ? Xe.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: te(a) ? a.find(
                    (A) => A.key === (Array.isArray(f) ? f[0] : f)
                  )?.value : f
                }
              ),
              onSelect: (b, A) => {
                const w = A?.toString(), v = Array.isArray(f) ? [w] : w;
                c ? c(v, g) : g(v), y(!1);
              },
              isOpen: m,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: [...a, ...l].map((b) => /* @__PURE__ */ t(
                Qe,
                {
                  value: ie(b),
                  description: !fe(b) && "description" in b ? b.description : void 0,
                  children: fe(b) ? b : b.value
                },
                ie(b)
              )) })
            }
          )
        }
      )
    }
  );
}, ee = (e) => fe(e) ? e : e.value, jr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: d,
  variant: c,
  isFullWidth: h = !0,
  ...u
}) => {
  const {
    control: p,
    formState: { errors: m }
  } = Re(), [y, R] = E(!1), [g, f] = E(""), [b, A] = E(0), [w, v] = E([]), x = ne(), B = ce(i.rules?.required) === !0, F = c === ue.typeaheadMulti, P = $(
    () => [
      ...a.filter(
        (C) => !l.map((I) => ee(I)).includes(ee(C))
      ),
      ...l
    ],
    [l, a]
  ), K = P.filter(
    (C) => ee(C).toLowerCase().startsWith(g.toLowerCase())
  ), H = (C, I) => {
    I.value.includes(C) ? (I.onChange(I.value.filter((T) => T !== C)), te(a) && v(
      w.filter((T) => T.key !== C)
    )) : (I.onChange([...I.value, C]), te(P) && v([
      ...w,
      P.find((T) => T.key === C)
    ]));
  }, j = (C, I) => {
    const T = K[b];
    switch (R(!0), C.key) {
      case "Enter": {
        C.preventDefault(), f(F ? "" : ee(T)), H(ie(T), I), R(!1), A(0);
        break;
      }
      case "Tab":
      case "Escape": {
        R(!1), I.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === ue.typeahead && I.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        C.preventDefault();
        let V = 0;
        C.key === "ArrowUp" && (b === 0 ? V = a.length - 1 : V = b - 1), C.key === "ArrowDown" && (b === a.length - 1 ? V = 0 : V = b + 1), A(V);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: B,
      error: N(m, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: p,
          render: ({ field: C }) => /* @__PURE__ */ t(
            Ae,
            {
              ...u,
              onOpenChange: () => R(!1),
              selected: te(P) ? P.filter(
                (I) => Array.isArray(C.value) ? C.value.includes(I.key) : C.value === I.key
              ).map((I) => I.value) : C.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (I) => /* @__PURE__ */ t(
                pe,
                {
                  ref: I,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    R(!y), x.current?.focus();
                  },
                  isExpanded: y,
                  isFullWidth: h,
                  status: N(m, n) ? Xe.danger : void 0,
                  children: /* @__PURE__ */ k(kt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      wt,
                      {
                        placeholder: o,
                        value: c === ue.typeahead && C.value ? te(P) ? P.find(
                          (T) => T.key === (Array.isArray(C.value) ? C.value[0] : C.value)
                        )?.value : C.value : g,
                        onClick: () => R(!y),
                        onChange: (T, V) => {
                          f(V), d?.(V);
                        },
                        onKeyDown: (T) => j(T, C),
                        autoComplete: "off",
                        innerRef: x,
                        role: "combobox",
                        isExpanded: y,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === ue.typeaheadMulti && Array.isArray(C.value) && /* @__PURE__ */ t(Ze, { "aria-label": "Current selections", children: C.value.map(
                          (T, V) => /* @__PURE__ */ t(
                            et,
                            {
                              onClick: (D) => {
                                D.stopPropagation(), C.onChange(
                                  C.value.filter(
                                    (O) => O !== ie(T)
                                  )
                                );
                              },
                              children: te(P) ? [
                                ...P,
                                ...w
                              ].find((D) => T === D.key)?.value : ee(T)
                            },
                            V
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(It, { children: (!!g || C.value) && /* @__PURE__ */ t(
                      q,
                      {
                        variant: "plain",
                        onClick: () => {
                          f(""), C.onChange(F ? [] : ""), x.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (I, T) => {
                I?.stopPropagation();
                const V = T?.toString();
                F && Array.isArray(C.value) ? (f(""), H(V || "", C)) : (C.onChange(Array.isArray(C.value) ? [V] : V), R(!1));
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ee, { children: K.map((I, T) => /* @__PURE__ */ t(
                Qe,
                {
                  value: ie(I),
                  isFocused: b === T,
                  isActive: C.value.includes(ee(I)),
                  description: !fe(I) && "description" in I ? I.description : void 0,
                  children: ee(I)
                },
                ie(I)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const te = (e) => typeof e[0] != "string", fe = (e) => typeof e == "string", ie = (e) => fe(e) ? e : e.key, Gr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(Hr, { ...n }) : /* @__PURE__ */ t(jr, { ...n, variant: e }), He = (e) => e && typeof e == "string" ? e.includes("${") : !1, je = (e) => e.substring(2, e.length - 1), re = (e, n, r, a) => {
  const l = n || r, i = He(l) ? je(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, Ge = (e, n) => re(e, n.displayName, n.name), Wr = ["username", "firstName", "lastName", "email"], Ut = (e) => e && Wr.includes(e), Q = (e) => `${Ut(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Ya = (e) => e.replaceAll(".", "🍺"), zr = (e) => e.replaceAll("🍺", ".");
function Qa(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => He(i) ? r(je(i)) : i)
    );
    n(Q(a.field), {
      message: r(
        He(a.errorMessage) ? je(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Fe({
  required: e
}) {
  return e;
}
function Xa(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Za = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Re();
  return /* @__PURE__ */ t(
    Y,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: d, value: c } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": zr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? c === "true" : c,
              onChange: (h, u) => {
                const p = n ? u.toString() : u;
                l.onChange?.(h, u), d(p);
              }
            }
          )
        }
      )
    }
  );
}, el = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = De({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Y,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        St,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? W.error : W.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, tl = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!ce(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = De({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ k(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          xe,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? W.error : W.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { children: r }) }) })
      ]
    }
  );
}, Jr = St, nl = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { t: i } = U(), [s, o] = E(""), { field: d, fieldState: c } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: c.error,
      children: /* @__PURE__ */ t(
        dn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? W.error : W.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (h, u) => {
            d.onChange(u), o(u.name);
          },
          onClearClick: () => {
            d.onChange(null), o("");
          },
          ...r,
          ...d
        }
      )
    }
  );
}, rl = ({ icon: e }) => {
  const n = Yr(e);
  return /* @__PURE__ */ t(qe, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Yr(e) {
  switch (e) {
    case "github":
      return sr;
    case "facebook":
      return ir;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const Qr = "_title_180i0_2", Xr = {
  title: Qr
}, $t = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  un,
  {
    headingLevel: r,
    size: a,
    className: Xr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Zr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Et();
  return /* @__PURE__ */ k(hn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(fn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t($t, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, ea = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t($t, { id: a, title: n }),
    r
  ] }) });
}, ta = "_panel_1cdve_1", na = "_sticky_1cdve_5", ht = {
  panel: ta,
  sticky: na
}, ra = "kc-main-content-page-container", _e = (e) => e.replace(/\s+/g, "-"), aa = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = $(
    () => n.filter(({ isHidden: o }) => !o),
    [n]
  ), [i, s] = E(0);
  return ae(() => {
    const o = document.getElementById(ra);
    if (!o) return;
    const d = 100, c = () => {
      const h = o.scrollTop + d;
      let u = 0;
      l.forEach(({ title: p }, m) => {
        const y = _e(p.toLowerCase()), R = document.getElementById(y);
        R && h >= R.offsetTop && (u = m);
      }), s(u);
    };
    return c(), o.addEventListener("scroll", c), () => o.removeEventListener("scroll", c);
  }, [l]), /* @__PURE__ */ k(gn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(st, { md: 8, sm: 12, children: l.map(({ title: o, panel: d }) => {
      const c = _e(o.toLowerCase());
      return /* @__PURE__ */ t(Rt, { children: r ? /* @__PURE__ */ t(
        Zr,
        {
          scrollId: c,
          title: o,
          className: ht.panel,
          children: d
        }
      ) : /* @__PURE__ */ t(ea, { scrollId: c, title: o, children: d }) }, o);
    }) }),
    /* @__PURE__ */ t(st, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(yn, { className: ht.sticky, children: /* @__PURE__ */ t(vn, { isVertical: !0, label: e, children: l.map(({ title: o }, d) => {
      const c = _e(o.toLowerCase());
      return /* @__PURE__ */ t(
        bn,
        {
          isActive: i === d,
          onClick: () => {
            const h = document.getElementById(c);
            h && h.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          },
          "data-testid": `jump-link-${c}`,
          children: o
        },
        o
      );
    }) }) }) })
  ] });
}, la = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, al = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  q,
  {
    variant: "primary",
    isDisabled: !la(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), ia = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, sa = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = $(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, ia(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(fr, { ...n, children: /* @__PURE__ */ t(
    Gr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = re(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), d = N(s, Q(r.name));
  return /* @__PURE__ */ k(
    Ct,
    {
      label: Ge(e, r) || "",
      fieldId: r.name,
      isRequired: Fe(r),
      labelIcon: i ? /* @__PURE__ */ t(Nt, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ k(Te, { children: [
          l,
          o
        ] }) : l,
        d && /* @__PURE__ */ t(
          _t,
          {
            "data-testid": `${r.name}-helper`,
            message: d.message
          }
        )
      ]
    },
    r.name
  );
}, oa = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  ca,
  {
    t: e,
    form: n,
    "aria-label": Ge(e, r),
    name: Q(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ge(e, r)
    }),
    isDisabled: r.readOnly,
    ...l
  }
) }), ca = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...d
}) => {
  const { register: c, setValue: h, control: u } = a, p = pr({
    name: n,
    control: u,
    defaultValue: s || ""
  }), m = $(() => Array.isArray(p) && p.length !== 0 ? p : s || [""], [p]), y = (A) => {
    f([...m.slice(0, A), ...m.slice(A + 1)]);
  }, R = () => {
    f([...m, ""]);
  }, g = (A, w) => {
    f([...m.slice(0, A), w, ...m.slice(A + 1)]);
  }, f = (A) => {
    const w = A.flatMap((v) => v);
    h(n, w, {
      shouldDirty: !0
    });
  }, b = r.startsWith("html") ? r.substring(6) : "text";
  return ae(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: m.map((A, w) => /* @__PURE__ */ k(Rt, { children: [
    /* @__PURE__ */ k(Te, { children: [
      /* @__PURE__ */ t(Ue, { isFill: !0, children: /* @__PURE__ */ t(
        xe,
        {
          "data-testid": n + w,
          onChange: (v, x) => g(w, x),
          name: `${n}.${w}.value`,
          value: A,
          isDisabled: i,
          type: b,
          ...d
        }
      ) }),
      /* @__PURE__ */ t(Ue, { children: /* @__PURE__ */ t(
        q,
        {
          "data-testid": "remove" + w,
          variant: Ie.link,
          onClick: () => y(w),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: m.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    w === m.length - 1 && /* @__PURE__ */ k(
      q,
      {
        variant: Ie.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !A || i,
        children: [
          /* @__PURE__ */ t(Pt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, w)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Fe(a), i = r.startsWith("multiselect"), s = i ? Cn : kn, o = a.validators?.options?.options || [], d = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: Q(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: h }) => /* @__PURE__ */ t(J, { children: o.map((u) => /* @__PURE__ */ t(
        s,
        {
          id: u,
          "data-testid": u,
          label: re(e.t, d[u], u, c),
          value: u,
          isChecked: h.value?.includes(u),
          onChange: () => {
            i ? h.value?.includes(u) ? h.onChange(
              h.value?.filter((p) => p !== u)
            ) : h.onChange([...h.value || [], u]) : h.onChange([u]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        u
      )) })
    }
  ) });
}, da = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: d,
  toggleIcon: c,
  className: h,
  isDisabled: u,
  children: p,
  ...m
}) => {
  const [y, R] = E(!1), g = ne(), f = () => {
    R(!y), n(!y);
  }, b = () => i === "parent" && g.current?.parentElement || "inline", A = Dt.toArray(
    p
  );
  return /* @__PURE__ */ t(
    Ae,
    {
      ref: g,
      maxMenuHeight: Se(d),
      isScrollable: !0,
      popperProps: {
        appendTo: b(),
        direction: s,
        width: Se(o)
      },
      ...m,
      onClick: f,
      onOpenChange: (w) => {
        w !== y && f();
      },
      selected: a,
      onSelect: (w, v) => {
        r?.(v || ""), f();
      },
      toggle: (w) => /* @__PURE__ */ t(
        pe,
        {
          id: e,
          ref: w,
          className: h,
          onClick: f,
          isExpanded: l,
          "aria-label": m["aria-label"],
          icon: c,
          isDisabled: u,
          isFullWidth: !0,
          children: A.find((v) => v.props.value === a)?.props.children || a || m["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ee, { children: p })
    }
  );
}, ua = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  onClear: l,
  variant: i,
  validated: s,
  placeholderText: o,
  maxHeight: d,
  width: c,
  toggleIcon: h,
  direction: u,
  selections: p,
  typeAheadAriaLabel: m,
  chipGroupComponent: y,
  chipGroupProps: R,
  footer: g,
  isDisabled: f,
  children: b,
  ...A
}) => {
  const [w, v] = E(""), [x, B] = E(!1), [F, P] = E(0), K = ne(), H = Dt.toArray(
    b
  ), j = a || !x || !w ? H : H.filter((D) => {
    const { children: O, value: L } = D.props;
    return (typeof O == "string" ? O : String(L ?? "")).toLowerCase().includes(w.toLowerCase());
  }), C = i === se.typeahead && !x && p ? p : w, I = () => {
    B(!1), v(""), P(0), a?.("");
  }, T = () => {
    r(!A.isOpen);
  }, V = (D) => {
    const O = j.at(F);
    switch (r(!0), D.key) {
      case "Enter": {
        if (D.preventDefault(), !O) break;
        n?.(O.props.value), r(!1), I();
        break;
      }
      case "Escape": {
        D.stopPropagation(), r(!1), I();
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        if (D.preventDefault(), j.length === 0) break;
        let L = 0;
        D.key === "ArrowUp" && (F === 0 ? L = j.length - 1 : L = F - 1), D.key === "ArrowDown" && (F === j.length - 1 ? L = 0 : L = F + 1), P(L);
        break;
      }
    }
  };
  return /* @__PURE__ */ k(
    Ae,
    {
      ...A,
      onClick: T,
      onOpenChange: (D) => {
        r(D), D || I();
      },
      onSelect: (D, O) => {
        n?.(O || ""), I();
      },
      maxMenuHeight: Se(d),
      popperProps: { direction: u, width: Se(c) },
      toggle: (D) => /* @__PURE__ */ t(
        pe,
        {
          ref: D,
          id: e,
          variant: "typeahead",
          onClick: () => r(!0),
          icon: h,
          isDisabled: f,
          isExpanded: A.isOpen,
          isFullWidth: !0,
          status: s === "error" ? Xe.danger : void 0,
          children: /* @__PURE__ */ k(kt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              wt,
              {
                placeholder: o,
                value: C,
                onClick: T,
                onChange: (O, L) => {
                  B(!0), v(L), P(0), a?.(L);
                },
                onKeyDown: (O) => V(O),
                autoComplete: "off",
                innerRef: K,
                role: "combobox",
                isExpanded: A.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": m,
                children: i === se.typeaheadMulti && Array.isArray(p) && (y || /* @__PURE__ */ t(Ze, { ...R, children: p.map((O, L) => /* @__PURE__ */ t(
                  et,
                  {
                    onClick: (ge) => {
                      ge.stopPropagation(), n?.(O);
                    },
                    children: O
                  },
                  L
                )) }))
              }
            ),
            /* @__PURE__ */ t(It, { children: !!C && /* @__PURE__ */ t(
              q,
              {
                variant: "plain",
                onClick: () => {
                  l ? l() : n?.(""), I(), K.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: j }),
        g && /* @__PURE__ */ t(wn, { children: g })
      ]
    }
  );
};
var se = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(se || {});
const Se = (e) => typeof e == "number" ? e + "px" : e, ha = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(da, { ...n }) : /* @__PURE__ */ t(ua, { ...n, variant: e }), pt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = E(!1), [o, d] = E(""), c = a === "multiselect", h = (g, f) => {
    c ? f.value?.includes(g) ? f.onChange(f.value.filter((b) => b !== g)) : Array.isArray(f.value) ? f.onChange([...f.value, g]) : f.onChange([g]) : f.onChange(g === f.value ? "" : g);
  }, u = l.validators?.options?.options || [], p = l.annotations?.inputOptionLabels || {}, m = l.annotations?.inputOptionLabelsI18nPrefix, y = (g) => re(e.t, p[g], g, m), R = (g) => u.filter(
    (f) => y(f).toLowerCase().includes(o.toLowerCase())
  ).map((f) => /* @__PURE__ */ t(
    Qe,
    {
      selected: Array.isArray(g) ? g.includes(f) : g === f,
      value: f,
      children: y(f)
    },
    f
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: Q(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: g }) => /* @__PURE__ */ t(
        ha,
        {
          toggleId: l.name,
          onToggle: (f) => s(f),
          onClear: () => h("", g),
          onSelect: (f) => {
            const b = f.toString();
            h(b, g), Array.isArray(g.value) || s(!1);
          },
          selections: c && Array.isArray(g.value) ? g.value.map((f) => y(f)) : y(g.value),
          variant: c ? se.typeaheadMulti : u.length >= 10 ? se.typeahead : se.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (f) => (d(f), R(g.value)),
          children: R(g.value)
        }
      )
    }
  ) });
}, fa = (e) => {
  const { form: n, attribute: r } = e, a = Fe(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Jr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, G = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Fe(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    xe,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : re(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(Q(a.name))
    }
  ) });
}, We = {
  text: G,
  textarea: fa,
  select: pt,
  "select-radiobuttons": ft,
  multiselect: pt,
  "multiselect-checkboxes": ft,
  "html5-email": G,
  "html5-tel": G,
  "html5-url": G,
  "html5-number": G,
  "html5-range": G,
  "html5-datetime-local": G,
  "html5-date": G,
  "html5-month": G,
  "html5-time": G,
  "multi-input": oa
}, ll = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = $(() => {
    if (!r.attributes)
      return [];
    const d = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: d.filter(
        (h) => h.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    aa,
    {
      label: e("jumpToSection"),
      sections: o.filter((d) => d.attributes.length > 0).map(({ group: d, attributes: c }) => ({
        title: re(e, d.displayHeader, d.name) || e("general"),
        panel: /* @__PURE__ */ k("div", { className: "pf-v5-c-form", children: [
          d.displayDescription && /* @__PURE__ */ t(ke, { className: "pf-v5-u-pb-lg", children: re(e, d.displayDescription, "") }),
          c.map((h) => /* @__PURE__ */ t(
            pa,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: h
            },
            h.name
          ))
        ] })
      }))
    }
  );
}, pa = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    Q(i.name)
  ), o = $(() => ga(i), [i]), d = i.multivalued || va(s) && i.annotations?.inputType === void 0 ? We["multi-input"] : We[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    sa,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    d,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, ma = "text";
function ga(e) {
  if (Ut(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ya(n) ? n : ma;
}
const ya = (e) => typeof e == "string" && e in We, va = (e) => Array.isArray(e) && e.length > 1, ba = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ k(
  "svg",
  {
    className: yr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ k("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), mt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = E(!1);
  return /* @__PURE__ */ t(
    In,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        pe,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Sn, { children: r })
    }
  );
};
function Ca(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const il = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: d = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: h = [],
  toolbarItems: u,
  toolbar: p,
  ...m
}) => {
  const { t: y } = U(), R = [];
  o && R.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: y("manageAccount")
      },
      "manageAccount"
    )
  ), s && R.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: y("signOut") }, "signOut")
  );
  const g = e.idTokenParsed?.picture;
  return /* @__PURE__ */ k(Tn, { ...m, children: [
    /* @__PURE__ */ t(xn, { children: /* @__PURE__ */ t(
      An,
      {
        "data-testid": "nav-toggle",
        variant: "plain",
        "aria-label": y("navigation"),
        children: /* @__PURE__ */ t(dr, {})
      }
    ) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ k(Rn, { children: [
      p,
      /* @__PURE__ */ t(we, { children: /* @__PURE__ */ k($e, { children: [
        u?.map((f, b) => /* @__PURE__ */ t(z, { align: { default: "alignRight" }, children: f }, b)),
        /* @__PURE__ */ t(
          z,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              mt,
              {
                "data-testid": "options",
                dropDownItems: [...h, R],
                title: d ? Ca(e.idTokenParsed, y) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              mt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || h,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: g || i?.src ? /* @__PURE__ */ t(Dn, { src: g, alt: y("avatar"), ...i }) : /* @__PURE__ */ t(ba, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Kt = tt("ErrorBoundaryContext", void 0), Ht = () => nt(Kt);
class sl extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Kt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const ol = ({ children: e, fallback: n }) => {
  const { error: r } = Ht();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ka(e, n, r) {
  const { showBoundary: a } = Ht();
  ae(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const wa = () => {
  const { t: e } = U();
  return /* @__PURE__ */ t(Fn, { children: /* @__PURE__ */ t(bt, { "aria-label": e("spinnerLoading") }) });
}, Ia = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: d = !1,
  children: c
}) => /* @__PURE__ */ k(On, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: ur }) : a && /* @__PURE__ */ t(ct, { icon: o || Pt }),
  /* @__PURE__ */ t(Pn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Ln, { children: n }),
  /* @__PURE__ */ k(Vn, { children: [
    i && /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: d,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ t(Mn, { children: s.map((h) => /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${h.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: h.type || Ie.secondary,
        onClick: h.onClick,
        isDisabled: d,
        children: h.text
      },
      h.text
    )) })
  ] })
] }), Sa = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: d } = U(), [c, h] = E(""), u = (m) => {
    h(m.trim()), o?.(m.trim());
  }, p = (m) => {
    m.key === "Enter" && u(c);
  };
  return /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t(we, { "data-testid": "table-toolbar", children: /* @__PURE__ */ k($e, { children: [
      i && /* @__PURE__ */ t(z, { children: /* @__PURE__ */ k(Te, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Bn,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": d("search"),
            value: c,
            onChange: (m, y) => {
              h(y);
            },
            onSearch: () => u(c),
            onKeyDown: p,
            onClear: () => u("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(we, { children: /* @__PURE__ */ t($e, { children: n }) }),
    /* @__PURE__ */ t(_n, {}),
    a,
    /* @__PURE__ */ t(we, { children: r })
  ] });
}, gt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: d } = U(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    Nn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${d("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: h,
        lastIndex: u
      }) => /* @__PURE__ */ k("b", { children: [
        h,
        " - ",
        u
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (h, u) => i((u - 1) * l),
      onPreviousClick: (h, u) => s((u - 1) * l),
      onPerPageSelect: (h, u, p) => o(p - 1, u),
      variant: n
    }
  );
}, Ta = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...d
}) => /* @__PURE__ */ t(
  Sa,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ k(J, { children: [
      r,
      /* @__PURE__ */ t(z, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, ...d }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(z, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, variant: "bottom", ...d }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, yt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ k(J, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(le, { children: jt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(le, { isActionCell: !0, children: /* @__PURE__ */ t(wr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, xa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function Aa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: d,
  canSelect: c,
  isNotCompact: h,
  isRadio: u,
  ...p
}) {
  const { t: m } = U(), [y, R] = E(i || []), [g, f] = E([]), b = $(
    () => mr(
      y,
      n.map((v) => v.data),
      "id"
    ),
    [y, n]
  );
  ae(() => {
    if (d) {
      const v = document.getElementsByName("check-all").item(0);
      if (v) {
        const x = v;
        x.indeterminate = b.length < n.length && b.length > 0;
      }
    }
  }, [y, d, n]);
  const A = (v) => {
    R(v), s?.(v);
  }, w = (v, x) => {
    if (u) {
      const B = x ? [n[v].data] : [];
      A(B);
    } else if (v === -1) {
      const B = b.map(
        (F) => N(F, "id")
      );
      A(
        x ? [...y, ...n.map((F) => F.data)] : y.filter(
          (F) => !B.includes(N(F, "id"))
        )
      );
    } else
      A(x ? [...y, n[v].data] : y.filter(
        (B) => N(B, "id") !== n[v].data.id
      ));
  };
  return /* @__PURE__ */ k(
    vr,
    {
      ...p,
      variant: h ? void 0 : br.compact,
      "aria-label": m(l),
      children: [
        /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ k(Ce, { children: [
          o && /* @__PURE__ */ t(Me, { screenReaderText: m("expandRow") }),
          d && /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: m("selectAll"),
              select: u ? void 0 : {
                onSelect: (v, x) => {
                  w(-1, x);
                },
                isSelected: b.length === n.length
              }
            }
          ),
          e.map((v) => /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: m("expandRow"),
              className: v.transforms?.[0]().className,
              children: m(v.displayKey || v.name)
            },
            v.displayKey || v.name
          ))
        ] }) }),
        o ? n.map((v, x) => /* @__PURE__ */ t(dt, { children: x % 2 === 0 ? /* @__PURE__ */ k(Ce, { children: [
          /* @__PURE__ */ t(
            le,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: g[x] ?? !1,
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (B, F, P) => {
                  o(P, F);
                  const K = [...g];
                  K[x] = P, f(K);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: v,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ k(Ce, { isExpanded: g[x - 1] ?? !1, children: [
          /* @__PURE__ */ t(le, {}),
          /* @__PURE__ */ t(le, { colSpan: e.length, children: /* @__PURE__ */ t(kr, { children: /* @__PURE__ */ t(xa, { row: v }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(dt, { children: n.map((v, x) => /* @__PURE__ */ k(Ce, { isExpanded: g[x], children: [
          c && /* @__PURE__ */ t(
            le,
            {
              select: {
                rowIndex: x,
                onSelect: (B, F, P) => {
                  w(P, F);
                },
                isSelected: !!y.find(
                  (B) => N(B, "id") === v.data.id
                ),
                variant: u ? "radio" : "checkbox",
                isDisabled: v.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: v,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function Ea({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: d,
  loader: c,
  columns: h,
  actions: u,
  actionResolver: p,
  searchTypeComponent: m,
  toolbarItem: y,
  subToolbar: R,
  emptyState: g,
  icon: f,
  isSearching: b = !1,
  ...A
}) {
  const { t: w } = U(), [v, x] = E([]), [B, F] = E(), [P, K] = E(), [H, j] = E(!1), [C, I] = Mt(
    localStorage,
    "pageSize",
    10
  ), [T, V] = E(C), [D, O] = E(0), [L, ge] = E(""), [Oe, Gt] = E(0), Wt = ne(), rt = () => Gt(Oe + 1), zt = Et(), Pe = (S) => {
    S !== L && (O(0), ge(S));
  }, at = (S, M) => S.map((_) => {
    if ("cellFormatters" in _) {
      const Z = N(M, _.name);
      return _.cellFormatters?.reduce((de, ve) => ve(de), Z);
    }
    if (_.cellRenderer) {
      const Z = _.cellRenderer;
      return { title: /* @__PURE__ */ t(Z, { ...M }) };
    }
    return N(M, _.name);
  }), lt = (S) => {
    const M = (_) => o?.[0]?.enabled?.(_);
    return S.map((_, Z) => {
      const de = d ? d(_) : !1, ve = [
        {
          data: _,
          disableSelection: de,
          disableActions: de,
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- lodash get performs dynamic property access at runtime
          selected: !!v.find((Zt) => N(Zt, "id") === N(_, "id")),
          isOpen: M(_) ? !1 : void 0,
          cells: at(h, _)
        }
      ];
      return o && ve.push({
        parent: Z * 2,
        cells: M(_) ? at(o, _) : []
      }), ve;
    }).flat();
  }, Le = (S) => ["string", "number"].includes(typeof S) ? S.toString() : S instanceof Array ? S.map(Le).join("") : typeof S == "object" ? Le(
    At(S.title) ? S.title.props : Object.values(S)
  ) : "", it = $(
    () => L === "" || r ? void 0 : lt(P || []).filter(
      (S) => S.cells.some(
        (M) => M && Le(M).toLowerCase().includes(L.toLowerCase())
      )
    ).slice(D, D + T + 1),
    [L, D, T]
  );
  ka(
    async () => (j(!0), await (typeof c == "function" ? c : "loader" in c ? c.loader : async () => c)(D, T + 1, L)),
    (S) => {
      Wt.current = Oe, r || (K(S), S.length > D ? S = S.slice(D, D + T + 1) : O(0));
      const M = lt(S);
      F(M), j(!1);
    },
    [
      Oe,
      D,
      T,
      L,
      typeof c != "function" ? "signal" in c ? c.signal : c : void 0
    ]
  );
  const Jt = () => u && gr(u).map((S, M) => (delete S.onRowClick, S.onClick = async (_, Z) => {
    await u[M].onRowClick(
      (it || B)[Z].data
    ) && (r || Pe(""), rt());
  }, S)), Yt = (S, M) => {
    X[M].isOpen = S, F([...X]);
  }, X = it || B, ye = !X || X.length === 0, Ve = L !== "" || b, Qt = o ? T * 2 : T, Xt = o ? (X?.length || 0) / 2 : X?.length || 0;
  return /* @__PURE__ */ k(J, { children: [
    (!ye || Ve) && /* @__PURE__ */ k(
      Ta,
      {
        id: zt,
        count: Xt,
        first: D,
        max: T,
        onNextClick: O,
        onPreviousClick: O,
        onPerPageSelect: (S, M) => {
          O(S), V(M), I(M);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Pe,
        inputGroupPlaceholder: w(n || ""),
        searchTypeComponent: m,
        toolbarItem: /* @__PURE__ */ k(J, { children: [
          y,
          " ",
          /* @__PURE__ */ t(z, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(z, { children: /* @__PURE__ */ k(q, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(hr, {}),
            " ",
            w("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !H && !ye && /* @__PURE__ */ t(
            Aa,
            {
              ...A,
              canSelectAll: l,
              canSelect: !!a,
              selected: v,
              onSelect: (S) => {
                x(S), a?.(S);
              },
              onCollapse: o ? Yt : void 0,
              actions: Jt(),
              actionResolver: p,
              rows: X.slice(0, Qt),
              columns: h,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !H && ye && Ve && /* @__PURE__ */ t(
            Ia,
            {
              hasIcon: !0,
              icon: f,
              isSearchVariant: !0,
              message: w("noSearchResults"),
              instructions: w("noSearchResultsInstructions"),
              secondaryActions: b ? [] : [
                {
                  text: w("clearAllFilters"),
                  onClick: () => Pe(""),
                  type: Ie.link
                }
              ]
            }
          )
        ]
      }
    ),
    H && /* @__PURE__ */ t(wa, {}),
    !H && ye && !Ve && g
  ] });
}
const Ra = ({ link: e, organization: n }) => {
  const { t: r } = U();
  return /* @__PURE__ */ t(Sr, { wrapModifier: "truncate", children: /* @__PURE__ */ k(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      qn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Da = (e) => {
  const { t: n } = U();
  return /* @__PURE__ */ t(
    Ze,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(et, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, cl = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: d,
  children: c,
  actions: h,
  membershipTypeRenderer: u
}) => {
  const { t: p } = U();
  return /* @__PURE__ */ t(
    Ea,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: [
        ...s ? [{ title: p(o), onRowClick: s }] : [],
        ...h ?? []
      ],
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (m) => /* @__PURE__ */ t(Ra, { link: d, organization: m })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Da
        },
        {
          name: "description",
          displayKey: "description"
        },
        ...u ? [
          {
            name: "membershipType",
            displayKey: "membershipType",
            transforms: [Ir(20)],
            cellRenderer: u
          }
        ] : []
      ],
      emptyState: c
    }
  );
};
export {
  Lr as AlertProvider,
  Wa as ContinueCancelModal,
  ol as ErrorBoundaryFallback,
  sl as ErrorBoundaryProvider,
  Vr as ErrorPage,
  nl as FileUploadControl,
  _t as FormErrorText,
  Zr as FormPanel,
  al as FormSubmitButton,
  Nr as Help,
  Nt as HelpItem,
  rl as IconMapper,
  Ea as KeycloakDataTable,
  il as KeycloakMasthead,
  ja as KeycloakProvider,
  ha as KeycloakSelect,
  wa as KeycloakSpinner,
  Jr as KeycloakTextArea,
  Ia as ListEmptyState,
  za as NumberControl,
  cl as OrganizationTable,
  Ta as PaginatingTableToolbar,
  Ja as PasswordControl,
  qt as PasswordInput,
  aa as ScrollForm,
  Gr as SelectControl,
  ue as SelectVariant,
  Za as SwitchControl,
  Sa as TableToolbar,
  el as TextAreaControl,
  tl as TextControl,
  ll as UserProfileFields,
  Ya as beerify,
  tt as createNamedContext,
  zr as debeerify,
  Rr as generateId,
  Ar as getErrorDescription,
  xr as getErrorMessage,
  Ga as getInjectedEnvironment,
  Er as getNetworkErrorDescription,
  Lt as getNetworkErrorMessage,
  He as isBundleKey,
  Dr as isDefined,
  Xa as isUserProfileError,
  re as label,
  ra as mainPageContentId,
  Qa as setUserProfileServerError,
  Ka as useAlerts,
  Ha as useEnvironment,
  Ht as useErrorBoundary,
  ka as useFetch,
  _r as useHelp,
  nt as useRequiredContext,
  Fr as useSetTimeout,
  Mt as useStoredState
};
//# sourceMappingURL=keycloak-ui-shared.js.map
